export default "__VITE_ASSET__cFqayZPD__"